var portfolioTransactionsList = {
	caption: "Portfolio transactions",
	date: "Datum",
	time: "Tijd",
	name: "Naam",
	isin: "ISIN",
	transactionType: "Soort",
	numberOfShares: "Aantal/Nominaal",
	executionPrice: "Uitvoeringsprijs",
	executionValue: "Uitvoeringswaarde",
	assetClass: "Activaklasse",
	actions: "Acties",
	buy: "Kopen",
	sell: "Verkopen",
	cash: "Contant Geld",
	payout: "Uitbetaling",
	short: "Short",
	cover: "Dekking",
	noTransactions: "Geen resultaten gevonden",
	bond: "Bond",
	commodity: "Commodity",
	currency: "Valuta",
	debt: "Debt",
	etf: "ETF",
	fund: "Fonds",
	generic: "Algemeen",
	index: "Index",
	stock: "Aandeel",
	interestRate: "Rente",
	structuredProduct: "Gestructureerd Product",
	investmentProduct: "Investeringsproduct",
	leveragedProduct: "Hefboomproduct",
	option: "Optie",
	future: "Future"
};
var nl = {
	portfolioTransactionsList: portfolioTransactionsList
};

export { nl as default, portfolioTransactionsList };
